// extracted by mini-css-extract-plugin
export default {"Form":"Form_Form__+pkW4"};